<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Add Schema"
              bc1="App"
              bc2="Add Schema"
              bc3="Add"
              path="schemas"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="name"
                                  id="name-icon"
                                  class="form-control"
                                  :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                  name="name"
                                  placeholder="Name"
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('name')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Currency</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                  v-model="currencyId"
                                  name="currencyId"
                                  size="sm"
                                  class=""
                                  v-validate="'required'"
                                  :class="
                                  errorBag.has('currencyId') ? 'is-invalid' : ''
                                "
                              >
                                <b-form-select-option value=""
                                >Please Select Currency
                                </b-form-select-option>
                                <b-form-select-option
                                    v-for="(item, index) in currencyRequestData"
                                    :value="item.id"
                                    :key="index"
                                >{{ item.code }}
                                </b-form-select-option>
                                <b-form-select-option
                                    v-show="
                                    !currencyRequestData
                                  "
                                    value="Please Select Currency"
                                ></b-form-select-option>
                              </b-form-select>
                              <small
                                  v-show="errorBag.has('currencyId')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("currencyId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="des-icon">Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="type">
                                <option :key="index" :value="index" v-for="(item, index) in typeList">{{ item }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="des-icon">Description</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <textarea
                                type="text"
                                v-model="description"
                                id="des-icon"
                                class="form-control"
                                name="description"
                                placeholder="Type here ..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Smart Routing</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="form-check mt-25">
                              <input class="form-check-input" type="checkbox" id="inlineCheckbox3ds" v-model="smart">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="">
                          <div class="mt-2">
                            <h4 class="card-title">Acquirings</h4>
                          </div>
                          <div class="card-body">
                            <form class="form form-horizontal">
                              <!--                    <div class="row border-primary badge-glow m-1 pt-2 pb-5" v-for="(acquiringFieldItem,acquiringFieldIndex) in acquiringFields" :key="acquiringFieldIndex">-->
                              <div class="row border-primary badge-glow m-1 pt-2 pb-5">
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div class="col-sm-12">
                                      <!--                            <div class="float-right">-->
                                      <!--                              <button-->
                                      <!--                                  type="button"-->
                                      <!--                                  class="btn btn-danger btn-sm"-->
                                      <!--                                  @click="removeField(acquiringFieldIndex)"-->
                                      <!--                              >-->
                                      <!--                                Remove-->
                                      <!--                              </button>-->
                                      <!--                            </div>-->
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div class="col-sm-3 col-form-label">
                                      <label>Payment Method </label>
                                    </div>
                                    <div class="col-sm-9">
                                      <div class="input-group">
                                        <b-form-select
                                            v-model="method"

                                            size="sm"

                                        >
                                          <b-form-select-option value=""
                                          >Please Select payment Method
                                          </b-form-select-option>
                                          <b-form-select-option
                                              v-for="(item, index) in paymentMethodRequestData"
                                              :value="item.id"
                                              :key="index"
                                          >{{ item.name }}
                                          </b-form-select-option>
                                          <b-form-select-option
                                              v-show="
                                    !paymentMethodRequestData
                                  "
                                              value="Please Select Payment Method"
                                          ></b-form-select-option>
                                        </b-form-select>

                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group row">
                                    <div class="col-sm-3 col-form-label">
                                      <label>Acquirings</label>
                                    </div>
                                    <div class="col-sm-9" v-if="aquireLoader">
                                      <div class="spinner-border text-primary"></div>
                                    </div>
                                    <div class="col-sm-9" v-else>
                                      <div v-for="(item,index) in acquiringCheckboxList" :key="index"
                                           class="form-check d-inline-flex mt-1 w-25">
                                        <input class="form-check-input" type="checkbox" :id="'inlineCheckbox'+index"
                                               v-model="item.checked">
                                        <label class="form-check-label"
                                               :for="'inlineCheckbox'+index">{{ item.name + '/' + item.code }}</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group row"></div>
                                  <div class="form-group row"></div>
                                  <div class="form-group row">
                                    <div class="col-12">
                                      <div class="demo-inline-spacing">
                                        <div class="position-relative d-inline-block"
                                             v-for="(item,index) in allSelectionNames">
                                          <div class="badge badge-light-dark ml-sm-50" v-if="item">{{ item.name+'/'+item.code }}
                                            <span class="badge badge-pill badge-danger badge-up" @click="removeField(item,index)">x</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex justify-content-end mt-1">
                        <button
                            type="button"
                            class="btn btn-primary mr-1"
                            @click="sendCall"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {

  mounted() {
    setTimeout(() => {
      this.selectCurrencyData()
      this.selectPaymentData()
      // this.getTransactionTypes()
    }, 1000);
  },
  data() {
    return {
      name: "",
      description: "",
      type: 0,
      typeList:[
          'Other',
          'CardPayment',
          'Applepay',
          'Googlepay',
      ],
      loading: false,
      size: "10px",
      currencyId: "",
      paymentMethodRequestData: [],
      currencyRequestData: [],
      setting: '',
      acquiringFields: [],
      acquiringCheckboxList: [],
      method: null,
      smart: false,
      aquireLoader: false,
      allSelections: [],
      allSelectionNames: []

    };
  },
  methods: {
    selectPaymentData() {
      this.makeRequest("post", "v1/get-payment-method", {
        flag: "active"
      }, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = [];
            data = callResponse.response.data.data;
            this.paymentMethodRequestData = data
            this.method = this.paymentMethodRequestData[0].id

          }
        }
      });
    },
    removeField(item,index) {
      var selctionIndex = this.allSelections.indexOf(item.id);
      if (selctionIndex !== -1) {
        this.allSelections.splice(selctionIndex, 1);
      }
      this.allSelectionNames.splice(index, 1);
    },
    addMore() {
      let params = {
        method: '',
      }
      this.acquiringFields.push(params)
    },
    selectCurrencyData() {
      this.makeRequest("post", "v1/get-currency", {flag: "active"}, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = [];
                data = callResponse.response.data.data;
                this.currencyRequestData = data
              }
            }
          }
      );
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {

          this.loading = true;
          // let selectedCheckboxes = []
          // //extracting ids to send with the request
          // this.acquiringCheckboxList.forEach(eachFeature => {
          //   if (eachFeature.checked) {
          //     selectedCheckboxes.push(eachFeature.id)
          //   }
          // })


          let data = {
            aquirings: JSON.stringify(this.allSelections),
            smartRouting: this.smart ? 1 : 0,
            currencyId: this.currencyId,
            name: this.name,
            description: this.description,
            type: this.type,
          }

          this.makeRequest("post", "v1/add-schema", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.$router.push({
                      name: "schema",
                    });
                  }

                }
                this.loading = false;
              }
          );
        }
      });
    },
    checkIdAlreadyExist(arr, id) {
      return (arr.indexOf(id) != -1);
    },

  },
  watch: {
    method(val) {
      this.aquireLoader = true
      this.makeRequest("post", "v1/get-aquiring", {status: "active", paymentMethodId: val}, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.acquiringCheckboxList = []
                let tempTransactionTypes = callResponse.response.data.data
                if (tempTransactionTypes) {
                  tempTransactionTypes.forEach(eachType => {
                    eachType.checked = false
                    this.acquiringCheckboxList.push(eachType)
                  })
                }

              }
              this.aquireLoader = false
            }
          }
      );
    },
    acquiringCheckboxList: {
      handler(val) {
        if (val) {
          val.forEach(eachFeature => {
            if (eachFeature.checked) {

              if (!this.checkIdAlreadyExist(this.allSelections, eachFeature.id)) {
                this.allSelectionNames.push(eachFeature)
                this.allSelections.push(eachFeature.id)

              }
            }
          })



        }



      },
      deep: true
    },
  }
};
</script>

